const drawer = document.querySelector('div#pp-cart-drawer');
const main = document.querySelector('main#mainContent');

if (drawer && main) {
  const observer = new MutationObserver(() => {
    const styles = window.getComputedStyle(drawer);
    const transform = styles.transform;
    const isVisible = styles.display !== 'none' && !transform.includes('-500');

    if (isVisible) {
      main.style.zIndex = '20000';
    } else {
      main.style.zIndex = '2';
    }
  });

  observer.observe(drawer, { attributes: true, attributeFilter: ['style', 'class'] });
}